import { CheckCircleIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';

interface CartOrOrder {
  moq?: number;
  totalQuantity?: number;
}

interface MoqAlertProps {
  cart?: CartOrOrder;
  order?: CartOrOrder;
  show?: (cartOrOrder: CartOrOrder) => boolean;
}

const CartMoqAlert = ({ cart, order, show }: MoqAlertProps) => {
  const entity = cart ?? order;
  if (!entity || entity.moq === undefined || entity.moq <= 0) return null;

  const met = entity.totalQuantity! >= entity.moq;
  const colors = met
    ? {
        bg: 'bg-green-50',
        border: 'border-green-200',
        text: 'text-green-800',
        icon: CheckCircleIcon,
        iconColor: 'text-green-600',
      }
    : {
        bg: 'bg-yellow-50',
        border: 'border-yellow-200',
        text: 'text-yellow-800',
        icon: ExclamationTriangleIcon,
        iconColor: 'text-yellow-600',
      };

  const Icon = colors.icon;

  return (
    <div
      key={met ? 'met' : 'not-met'}
      className={`mb-4 rounded-2xl ${colors.bg} border ${colors.border} p-4 flex items-start gap-3 shadow-sm ${show?.(entity) === false ? 'hidden' : ''}`}
    >
      <Icon className={`h-6 w-6 shrink-0 ${colors.iconColor}`} />
      <div className={`flex-1 text-sm ${colors.text}`}>
        {met
          ? `Minimum order quantity met! You have ${entity.totalQuantity} items in your ${cart ? 'cart' : 'order'}.`
          : `Minimum order quantity (${entity.moq}) has not been met. You currently have ${entity.totalQuantity} items in your ${cart ? 'cart' : 'order'}.`}
      </div>
    </div>
  );
};

export default CartMoqAlert;
